import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "roleFunctionality",
})
export class RoleFunctionalityPipe implements PipeTransform {
  constructor() { }
  transform(functionality) {
    switch (functionality) {
      //ADMINISTRATION MODULE
      case "adminTerms":
        return "Términos y Condiciones";
      case "adminVehicles":
        return "Vehículos";
      case "adminSatelliteLock":
        return "Candados Satelitales";
      case "adminTrailers":
        return "Trailers";
      case "adminCompanies":
        return "Empresas";
      case "adminThirdParty":
        return "Terceros";
      case "createThirdParty":
        return "Crear terceros";
      case "createThirdPartyAddress":
        return "Crear direcciones de terceros";
      case "updateCompanyUtilitiesUnrestricted":
        return "Actualizar utilidades de la empresa sin restricción";
      case "adminUsers":
        return "Usuarios";
      case "setupMonitorIntegration":
        return "Habilitar/Deshabilitar integración GPS (Servicio con costo)";
      case "truoraConfiguration":
        return "Habilitar/Deshabilitar estudio de seguridad";
      case "vehicleDocumentsConfiguration":
        return "Configurar documentos adicionales requeridos del vehículo";
      case "editAdditionalServicesUtilities":
        return "Configurar utilidades de servicios adicionales";
      case "showDocumentsPendingDrivers":
        return "Mostrar conductores con documentos por validar";
      case "validateDocumentsPendingDrivers":
        return "Validar documentos pendientes de conductores";
      case "showSecurityAnalysis":
        return "Mostrar análisis de seguridad";
      case "disableEnableUsers":
        return "Desactivar / Activar usuarios";
      case "disableEnableDriver":
        return "Desactivar / Activar conductores";
      case "activateByScore":
        return "Activar conductores por puntaje bajo";
      case "createTermsConditions":
        return "Crear terminos y condiciones";
      case "downloadFileRegistreBank":
        return "Descargar archivo para pagos";
      case "createVehicle":
        return "Crear vehículos";
      case "createSatelliteLock":
        return "Crear candados satelitales";
      case "updateSatelliteLock":
        return "Editar candados satelitales";
      case "deleteSatelliteLock":
        return "Eliminar candados satelitales";
      case "assignSatelliteLock":
        return "Asignar candados satelitales";
      case "updateVehicle":
        return "Editar información de vehículos";
      case "editFieldsRUNT":
        return "Editar campos RUNT";
      case "activateVehicle":
        return "Activar vehículos";
      case "updateBankAdvance":
        return "Actualizar información bancaria de anticipos | Vehículos";
      case "updateBankBalance":
        return "Actualizar información bancaria de saldos | Vehículos";
      case "createCompany":
        return "Crear empresas";
      case "updateCompany":
        return "Actualizar empresas";
      case "createRoles":
        return "Crear roles";
      case "updateRoles":
        return "Actualizar roles";
      case "changeRole":
        return "Cambiar usuario de rol";
      case "adminRoles":
        return "Roles";
      case "adminModules":
        return "Módulos";
      case "changeDriverVehicle":
        //No se usa esta funcionalidad por ahora
        return "Cambiar conductor del vehículo";
      case "validateAndRemarkVehicleReferences":
        return "Validar y anotar las referencias de los vehículos";
      case "showCreateGps":
        //No se usa ni está referenciada en ningúna parte
        return "Crear GPS";
      case "modifyBasicFieldsUser":
        return "Modificar información básica del usuario";
      case "showDeleteGps":
        return "Eliminar GPS";
      case "useGpsPortable":
        return "Usar GPS portable";
      case "alertValidGps":
        return "Alertar GPS válido para iniciar servicios";
      case "editCompliments":
        return "Editar requisitos de cumplido";
      case "createCompanyComplimentType":
        return "Agregar tipos de requisitos de cumplido";
      case "editTags":
        return "Editar etiquetas en la empresa";
      case "updateCity":
        return "Actualizar ciudades";
      case "linkCities":
        return "Enlazar subciudades y ciudades principales";
      case "addSubCities":
        return "Añadir subciudades";
      case "deleteSubCities":
        return "Eliminar subciudades";
      case "createEmailCompany":
        return "Añadir correos de la compañía";
      case "deleteEmailCompany":
        return "Eliminar correos de la compañía";
      case "routeDetourConfiguration":
        return "Configurar alerta por desvío de ruta";
      case "transportCompanyBlackListConfiguration":
        return "Configurar lista de empresas restringidas de transporte";
      case "riskProfileConfiguration":
        return "Configurar perfil de riesgo";
      case "requiresPreValidation":
        return "Configurar validación previa a facturación";
      case "prebillRequiresValidation":
        return "Configurar si las prefacturas requieren validación";
      case "reassignTrailer":
        return "Reasignar trailer de un vehículo";
      case "activateOrDeactivateCompany":
        return "Activar/Desactivar empresas";
      case "forceVehicleActivation":
        return "Forzar la activación de un vehículo";
      case "requestValidation":
        return "Solicitar validación de un vehículo";
      case "manageSecurityStudy":
        return "Generar y finalizar estudios de seguridad";
      case "deactivateVehicle":
        return "Desactivar vehículo";
      case "validateVehicleDocuments":
        return "Validar los documentos de un vehículo";
      case "editAdminVehicle":
        return "Editar Administrador de un Vehículo";
      case "editOwnerVehicle":
        return "Editar propietario de un vehículo";
      case "editGpsVehicle":
        return "Editar GPS de un vehículo";
      case "editReferencesVehicle":
        return "Editar referencias y contacto de un vehículo";
      case "turnCreation":
        return "Crear enturnamiento";
      case "reactivateVehicleByInactivity":
        return "Reactivar vehículo por inactividad";
      case "changeFeeToOwnedFleet":
        return "Cambiar la frecuencia de uso de flota propia";
      case "changeFleetLoyalty":
        return "Configurar los descuentos de la flota";
      case "changeVehicleFleetLoyalty":
        return "Configurar la categoría de la flota de un vehículo";
      case "changeValidationRules":
        return "Cambiar las reglas de validación del vehículo";
      case "changeRolNotifications":
        return "Cambiar las notificaciones de un rol";
      case "automaticTotalCostCalculation":
        return "Calculo automático del flete"
      case "maintenanceDetail":
        return "Detalle de mantenimiento";
      case "createMaintenance":
        return "Crear mantenimiento";
      case "editMaintenance":
        return "Editar mantenimiento";
      case "deleteMaintenance":
        return "Eliminar mantenimiento";
      case "duplicateTransportRequest":
        return "Duplicar Servicio";
      case "linkServices":
        return "Crear servicios consolidados";
      case "unlinkServices":
        return "Desasociar servicios consolidados";
      case "replicateChanges":
        return "Replicar los cambios de un servicio en otros";
      case "updatePolicy":
        return "Actualizar póliza(s)";
      case "setUpPolicy":
        return "Configurar póliza(s)";
      case "changeCommercial":
        return "Cambiar comercial asociado a empresa";
      case "createDriver":
        return "Crear conductor";
      case "editThirdPartyAddress":
        return "Editar dirección de tercero";
      case "disableEnableThirdParty":
        return "Desactivar / Activar Direcciones de terceros";

      //CARGO MODULE
      case "createManualCargo":
        return "Crear servicio manual";
      case "createCargoRequest":
        return "Crear solicitudes de servicio";
      case "changeTransportCompany":
        return "Cambiar empresa de transporte";
      case "viewRndc":
        return "Retransmisión RNDC";
      case "changeManifestRequirement":
        return "Cambiar requerimiento de manifiesto";
      case "searchCargo":
        return "Rastrear servicios"
      case "createCargoByGuides":
        return "Crear servicio por guías";
      case "createMassiveCargo":
        return "Crear servicio masivo";
      case "createCargoFromRoute":
        return "Crear servicio desde una ruta";
      case "createEscortService":
        return "Crear servicios de escolta";
      case "createSatelliteLockService":
        return "Crear servicios de candado satelital";
      case "cargoRequest":
        return "Solicitudes";
      case "cargoRequestNegotiation":
        return "Negociación B2B";
      case "cargosInRoute":
        return "Servicios en ruta";
      case "scheduledCargo":
        return "Servicios programados";
      case "cargosInNegotiation":
        return "Servicios en negociación";
      case "finishedCargos":
        return "Servicios terminados";
      case "prevalidationCargos":
        return "Prevalidación de servicios";
      case "validateCargo":
        return "Validar servicios";
      case "reverseValidateCargo":
        return "Revertir validación de servicios";
      case "viewValidateCargoInfo":
        return "Ver información de validación de servicios";
      case "reports":
        return "Reportes";
      case "cargoItemFinancier":
        return "Servicio financiero";
      case "registerLocation":
        return "Agregar localización de conductor";
      case "showManifestError":
        return "Mostrar servicios con error en el manifiesto";
      case "rateCargo":
        return "Calificar servicios";
      case "uploadExternalManifest":
        return "Cargar manifiesto externo";
      case "editTravelExpenses":
        return "Editar viáticos de servicios";
      case "removeTravelExpenses":
        return "Eliminar viáticos de servicios";
      case "removeAcceptedTravelExpenses":
        return "Eliminar viáticos de servicios aunque estén aprobados";
      case "readDriverDetails":
        return "Leer los detalles del conductor";
      case "documentManifest":
        return "Acceder al manifiesto del servicio";
      case "cancelManifest":
        return "Anular el manifiesto del servicio";
      case "viewRndcFulfillManifestConsignmentHistory":
        return "Ver responsable de cumplido del manifiesto y remesas";
      case "documentManifestUrban":
        return "Acceder a la Planilla urbana";
      case "documentConsignment":
        return "Acceder a la remesa del servicio";
      case "documentConsignmentUrban":
        return "Acceder a la guía terrestre";
      case "documentOrderVehicle":
        return "Acceder a la orden de cargue/servicio";
      case "readManifest":
        return "Leer el manifiesto del servicio o equivalente";
      case "createRoundedCargo":
        return "Crear servicio redondo";
      case "watchLiveGPS":
        //Está declarado pero no se usa
        return "Ver el GPS en vivo";
      case "modifyShippingCost":
        return "Agregar bonificaciones y descuentos";
      case "editCompliment":
        return "Editar cumplido inicial";
      case "readCargoCompliments":
        return "Consultar requisitos de cumplido";
      case "readDeletedCargoCompliments":
        return "Ver documentos eliminados de requisitos de cumplido";
      case "viewDeletedThirdpartyAddresses":
        return "Ver direcciones de terceros desactivadas";
      case "editCargoCompliments":
        return "Editar requisitos de cumplido del servicio";
      case "editCargoComplimentRequirements":
        return "Editar solo requisitos de cumplido individuales";
      case "uploadEvidences":
        return "Cargar evidencias";
      case "uploadExtraDocumentsCargo":
        return "Cargar evidencias extras";
      case "continueTripWithoutEvidences":
        return "Terminar servicio sin evidencias";
      case "removeEvidences":
        return "Eliminar las evidencias de un servicio";
      case "confirmLicensePlate":
        return "Confirmar vehículos";
      case "assignLicensePlate":
        return "Asignar vehículo";
      case "confirmLicensePlateOfLowRiskCargo":
        return "Confirmar vehículos de servicios de bajo riesgo";
      case "startCargo":
        return "Iniciar servicios";
      case "removeCargo":
        return "Eliminar servicios";
      case "cancelCargo":
        return "Desasociar vehiculo de servicio";
      case "approvePayments":
        return "Aprobación o rechazo de servicios";
      case "approvePaymentsWithTravelExpensesPending":
        return "Aprobación de servicios con viáticos pendientes por legalizar";
      case "rndcFulfillments":
        return "Listado de cumplidos RNDC";
      case "fulFillCargosRndc":
        return "Cumplir servicios RNDC";
      case "expiredCargo":
        return "Servicios expirados";
      case "showRateCargo":
        return "Mostrar tarifa de servicio";
      case "createRequestFromManualCreationCargo":
        return "Crear solicitud desde creación de servicio";
      case "createCargoFromRequest":
        return "Crear servicio desde solicitud";
      case "showTotalCostCargo":
        return "Mostrar flete de servicio";
      case "showPaymentCargo":
        return "Mostrar historial de pagos";
      case "showAnomaliesCargo":
        return "Mostrar historial de novedades";
      case "restoreCargo":
        return "Restaurar servicio";
      case "editCargo":
        return "Editar servicios"
      case "finishCargo":
        return "Finalizar servicios";
      case "changeCompany":
        return "Cambiar compañía";
      case "reportAnomalies":
        return "Reportar novedades";
      case "changeRteica":
        return "Cambiar Reteica";
      case "transportedValueSemaphore":
        return "Semáforo por valor declarado o perfil de riesgo";
      case "advanceRequest":
        return "Solicitar pago de anticipo";
      case "moveAdvance":
        return "Trasladar anticipo";
      case "changeCargoLoadDate":
        return "Iniciar servicios sin restricción de fecha";
      case "paymentSemaphore":
        return "Semáforo de pago";
      case 'additionalCosts':
        return 'Servicios adicionales';
      case "additionalCostCreate":
        return "Crear servicios adicionales";
      case "additionalCostUpdate":
        return "Actualizar servicios adicionales";
      case "additionalCostDelete":
        return "Eliminar servicios adicionales";
      case "approveSemaphore":
        //Está declarado pero no se usa
        return "Semáforo de aprobación";
      case "showBillingData":
        return "Mostrar información de Facturación";
      case "generateAccountingFiles":
        return "Generar archivos contables";
      case "downloadJournalCargoPDF":
        return "Descargar PDF Comprobante Contable";
      case "generateJournalCargo":
        return "Generar Comprobante Contable";
      case "deletedCargo":
        return "Servicios eliminados";
      case "changeRateFullAccess":
        return "Agregar bonificaciones y descuentos sin restricción";
      //Ver el GPS en vivo (PERMISO ERRONEO!)
      case "createCargoByRoute":
        //Permiso declarado pero no se usa
        return 'Crear servicio por ruta';
      case 'showCostCargo':
        return 'Mostrar costos de servicio'
      case 'editAnomalies':
        return 'Modificar eventos de trazabilidad'
      case "confirmationAdditionalMandatoryServices":
        return "Confirmación de servicios adicionales obligatorios";
      case "editWeightConsignment":
        return "Editar peso de la remesa";
      case "editCargoAmount":
        return "Editar el valor declarado de la mercancia";
      case "bonusAndDiscountsInCargoRejected":
        return "Bonos y descuentos a servicio rechazado";
      case "sendEmailReportsLastLocations":
        return "Agregar correos envío reporte últimas localizaciones";
      case "createCargosWithoutMinimumUtility":
        return "Crear servicios urbanos de contenedor vacío sin restricción de utilidad";
      case 'showCreationDateCargo':
        return "Ver fecha de creación de servicios";
      case "editCargoTags":
        return "Editar etiquetas del servicio";
      case "editCargoCompliments":
        return "Editar cumplidos del servicio";
      case 'restartCargo':
        return 'Reiniciar servicios';
      case 'approveCargoUnrestricted':
        return 'Aprobar servicios sin restricción';
      case 'removeCargoUnrestricted':
        return 'Anular servicios creados por otros usuarios';
      case 'removeCargoWithPayments':
        return 'Anular servicios con pagos';
      case "loadDownloadStatePoints":
        return "Estado puntos del servicio";
      case "trackingReports":
        return "Reportes de seguimiento";
      case "addDocumentsSupport":
        return "Agregar soporte de documentos";
      case "saveDriverDocuments":
        return "Guardar documentos del conductor";
      case "sendEmailReport":
        return "Enviar reportes al correo";
      case "editAdvance":
        return "Editar anticipo";
      case "deletePayment":
        return "Eliminar pagos de un servicio";
      case "deleteBalancePayment":
        return "Eliminar pago del saldo de un servicio";
      case "deleteBonusesAndDiscounts":
        return "Eliminar bonos y descuentos de un servicio";
      case "showDeletedBonusesAndDiscounts":
        return "Ver bonos y descuentos eliminados";
      case "showDeletedPayments":
        return "Ver pagos eliminados";
      case "editAddressCargoDurationTime":
        return "Editar tiempos registrados de un servicio";
      case "editTypeVehicle":
        return "Editar tipo de vehículo";
      case "addObservation":
        return "Editar observaciones del servicio";
      case "editSatelliteLockModule":
        return "Sección ver y editar candado satelital del servicio";
      case "earlyUploadEvidences":
        return "Subir evidencias de forma temprana";
      case "readVehicleDetails":
        return "Leer los detalles del vehículo";
      case "turn":
        return "Enturnamiento";
      case "editTurn":
        return "Editar enturnamiento";
      case "deleteTurn":
        return "Eliminar enturnamiento";
      case "viewAvailableLoads":
        return "Visualizar servicios disponibles";
      case "assignAvailableLoads":
        return "Asignar servicios disponibles";
      case "viewTurnVehicles":
        return "Visualizar vehículos enturnados";
      case "assignTurnVehicles":
        return "Asignar vehículos enturnados";
      case "additionalServicesWithoutUtilityRestriction":
        return "Servicios adicionales sin restricción";
      case "viewApproveInfo":
        return "Visualizar detalles de aprobación"
      case "approvedBelowSicetac":
        return "Aprobar servicios por debajo del SICETAC";
      case "evidencesFingerprint":
        return "Visualizar quien registró las evidencias";
      case "complimentsFingerprint":
        return "Visualizar quien registró los documentos requeridos de cumplido";
      case "startServiceWithArlExpired":
        return "Iniciar servicios con ARL vencida";
      case "startServiceWithEpsExpired":
        return "Iniciar servicios con EPS vencida";
      case "startServiceWithAdditionalCertificationsInvalid":
        return "Iniciar servicios con certificados adicionales inválidos";
      case "enableSimultaneousInrouteLoading":
        return "Habilitar servicios en ruta simultánea";
      case "useCarWithExpiredDocuments":
        return "Utilizar vehículos con documentación vencida";
      case "payWithTravelExpenses":
        return "Pagar los viáticos en el pago de anticipos";
      case "changeApprovedTravelExpenses":
        return "Realizar cambios a viáticos legalizados";
      case "reverseInitialComplitment":
        return "Anular los cumplidos iniciales";
      case "createBonusOrPenaltyToCargo":
        return "Crear conceptos de modificaciones al flete y tarifa de un servicio";
      case "serviceRequests":
        return "Solicitudes de servicio";
      case "createTransportRequests":
        return "Crear solicitudes";
      case "createApplications":
        return "Crear Postulaciones";
      case "editApplications":
        return "Editar Postulaciones";
      case "approveBonusFromApplication":
        return "Asignar postulaciones sin restricción";
      case "showOriginAddresses":
        return "Mostrar direcciones de origen";
      case "showDestinationAddresses":
        return "Mostrar direcciones de destino";
      case "showConsignmentServiceModule":
        return "Sección ver remesas del servicio";
      case "editConsignmentServiceModule":
        return "Sección editar remesas del servicio";
      case "allowToEditGeneralDataModule":
        return "Sección editar datos generales del servicio";
      case "showEditTagsModule":
        return "Sección editar etiquetas del servicio";
      case "editServiceTypeModule":
        return "Sección editar tipo de servicio";
      case "editPublicationZone":
        return "Editar zona de publicación del servicio";
      case "showServiceTypeModule":
        return "Sección ver tipo de servicio";
      case "editServiceCharacteristicsModule":
        return "Sección editar características del servicio";
      case "editRiskProfile":
        return "Editar perfil de riesgo del servicio";
      case "overrideRiskValidation":
        return "Guardar el servicio aunque no cumpla las reglas de riesgo (vehículo, tipo de viaje o valor)";
      case "showServiceCharacteristicsModule":
        return "Sección ver características del servicio";
      case "editLoadDownloadModule":
        return "Sección editar origen y destino del servicio";
      case "showInitialFulfill":
        return "Sección ver cumplidos iniciales";
      case "showLoadDownloadModule":
        return "Sección ver origen y destino del servicio";
      case "showFinancialInformationModule":
        return "Sección ver información financiera del servicio";
      case "showEditFinancialInformationModule":
        return "Sección editar información financiera del servicio";
      case "reduceScheduledTransportFreightCost":
        return "Reducir flete en servicios programados";
      case "viewFreightCostChangeHistory":
        return "Ver historial de cambios del flete";
      case "approveRndcWithoutAuthorization":
        return "Aprobar servicios sin autorización de RNDC";
      case "viewRndcApprovalFingerprint":
        return "Ver aprobaciones de contingencia RNDC";
      case "retransmitRndc":
        return "Retransmitir servicios al RNDC";
      case "viewRoutePlanChangeHistory":
        return "Ver historial de cambios del plan de ruta";
      case "showEditServiceNegotiationModule":
        return "Sección editar negociación del servicio";
      case "showEditRequestNegotiationModule":
        return "Sección editar negociación de la solicitud";
      case "showEndServiceInfoModule":
        return "Sección ver información de finalización del servicio";
      case "showTrailerReassignmentInfoModule":
        return "Ver información de desvinculación del trailer";
      case "showDeleteServiceInfoModule":
        return "Sección ver información de eliminación del servicio";
      case "showAssignedServiceInfoModule":
        return "Sección ver información de asignación del servicio";
      case "showCargoCreator":
        return "Sección ver información del creador del servicio";
      case "editCargoFingerprint":
        return "Editar responsables del servicio";
      case "showApprovalServiceInfoModule":
        return "Sección ver información de confirmación del vehículo del servicio";
      case "showDriverInfoModule":
        return "Sección ver información del conductor del servicio";
      case "showEscortInfoModule":
        return "Sección ver información de escolta del servicio";
      case "showActionsServiceModule":
        return "Sección ver acciones del servicio";
      case "createService":
        return "Crear Remesas/Servicios";
      case "createCargoWithRateOrCostZero":
        return "Crear servicios con tarifa o costo cero";
      case "generateManifest":
        return "Generar manifiesto";
      case "changeAssignSecondDriver":
        return "Cambiar o asignar segundo conductor";
      case "deleteSecondDriver":
        return "Eliminar segundo conductor";
      case "activateSecondDriver":
        return "Activar segundo conductor";
      case "createServicesWithExpiredPolicy":
        return "Crear servicios con póliza vencida";
      case "editConsignment":
        return "Editar remesas";
      case "generateNewConsignment":
        return "Generar nuevas remesas en servicios creados";
      case "deleteConsignment":
        return "Anular remesas individuales";
      case "assignUnassignCostCenterToService":
        return "Asignar/Desasignar centro de costo a un servicio";
      case "viewLogisticTimes":
        return "Ver tiempos logísticos";
      case "editLogisticTimes":
        return "Editar tiempos logísticos";
      case "panelAssignments":
        return "Panel de asignaciones";
      case "changeDispatchState":
        return "Editar el estado de despacho de un servicio";
      case "viewHistoryDispatchStateChanges":
        return "Ver historial de cambios de estados de despacho";
      //PAYMENT MODULE
      case "approveBankAdvance":
        return "Aprobar información bancaria de anticipos | Vehículos";
      case "approveBankBalance":
        return "Aprobar información bancaria de saldos | Vehículos";
      case "adminCities":
        return "Ciudades";
      case "charges":
        return "Facturar servicios";
      case "createCostCenter":
        return "Crear centros de costo";
      case "associateCostCenter":
        return "Asociar centros de costo";
      case "paymentExtraAdvance":
        return "Pagar sobreanticipos";
      case "billingXML":
        return "Realizar facturación XML";
      case "reverseApproval":
        return "Reversar aprobaciones";
      case 'paymentTravelExpenses':
        return 'Pagar viáticos';
      case "paymentBalance":
        return "Pagar saldos";
      case "paymentAdditionalCosts":
        return "Pagar servicios adicionales";
      case "paymentAdvance":
        return "Pagar anticipos";
      case "paymentCargo":
        return "Pagar servicios";
      case "travelExpensesChecking":
        return "Consultar viáticos";
      case "preBill":
        return "Prefacturación";
      case "financialActionsAfterApproval":
        return "Acciones financieras después de aprobar servicios";
      case "editSimpleRegimen":
        return "Editar régimen simple";
      case "modifyAdditionalCostBilled":
        return "Editar servicios adicionales con servicio facturado o validado para facturar";
      case "modifyAdditionalCostpayed":
        return "Editar servicios adicionales con servicio pagados";
      case "deleteAdditionalServicesBilled":
        return "Eliminar servicios adicionales con servicio validado para facturar";
      case "deleteAdditionalServicesApproved":
        return "Eliminar servicios adicionales con servicio aprobado";
      case "approveRejectedInspection":
        return "Aprobar inspecciones rechazadas";
      case "addAdditionalServiceCargoPaid":
        return "Crear servicios adicionales en servicios pagados";
      case "addAdditionalServiceCargoCashed":
        return "Crear servicios adicionales en servicios validados para facturar";
      case "addAdditionalServiceCargoApproved":
        return "Crear servicios adicionales en servicios aprobados";
      case "editRateCargoUnrestricted":
        return "Bonos y descuentos sin restricción";
      case "fastPaymentRequest":
        return "Solicitud de pronto pago";
      case "adminReceivable":
        return "Cartera";
      case "createReceivable":
        return "Crear carteras";
      case "deleteReceivable":
        return "Eliminar carteras";
      case "viewPaymentsReceivables":
        return "Ver abonos de carteras";
      case "billingWithFlexibilityChoice":
        return "Facturación con flexibilidad de elección";
      case "unrestrictedAdvancePayments":
        return "Pagar anticipos sin restricción";
      case "unrestrictedAdvancePaymentsRequest":
        return "Solicitar anticipos sin restricción";
      case "adminMaintenance":
        return "Mantenimientos";
      case "deleteCostCenter":
        return "Eliminar/desasociar centro de costo";
      case "doPaymentsReceivable":
        return "Abonar a cartera";
      //GUIDES MODULE
      case "loadGuides":
        return "Cargar guías";
      case "changeStateGuides":
        return "Cambiar estado de guías";
      case "createGuidesFromExcel":
        return "Crear guías desde XLS";
      case "guideList":
        return "Listado de guías";
      case "trackGuide":
        return "Rastreo de guías";
      case "editGuideNovelties":
        return "Editar configuración de guías";
      case "addNoveltyToGuide":
        return "Agregar novedades a guías";
      case "editUseEvidenceToGuides":
        return "Editar uso de evidencias en guías";
      //POINTS MODULE
      case "createPoint":
        return "Crear puntos";

      case "listPoints":
        return "Ver puntos";
      case "removePoint":
        return "Eliminar puntos";
      case "updatePoint":
        return "Actualizar puntos";

      //CONFIG MODULE
      case "companyDocuments":
        return "Documentos de la empresa";
      case "changePassword":
        return "Cambiar contraseña";
      case "termsAndConditions":
        return "Términos y condiciones";
      case "privacyPolicy":
        return "Políticas de privacidad";
      case "personalDataPolicies":
        return "Políticas tratamiento de datos personales";
      case "habeasData":
        return "HABEAS DATA";
      case "termsManifest":
        return "Anexo manifiesto de servicio";
      case "bascPolicies":
        return "Políticas BASC";
      case "quickPay":
        return "Pronto pago";
      // ROUTES MODULE
      case "routes":
        return "Rutas";
      case "routePlanning":
        return "Planes de ruta";
      case "createRoutePlanning":
        return "Crear planes de ruta";
      case "createRouteItinerary":
        return "Crear itinerarios de ruta";
      case "editRouteItinerary":
        return "Editar itinerarios de ruta";
      case "routeSites":
        return "Sitios Autorizados"
      case "createRouteSites":
        return "Crear sitios autorizados";
      case "editRouteSites":
        return "Editar sitios autorizados";
      case "deleteRouteSites":
        return "Eliminar sitios autorizados";
      case "routeCriticZones":
        return "Zonas críticas";
      case "createCriticZones":
        return "Crear zonas críticas";
      case "editCriticZones":
        return "Editar zonas críticas";
      case "accessCargoRoutePlanning":
        return "Ver el PDF del plan de ruta de un servicio";
      case "editCargoRoutePlanning":
        return "Editar el plan de ruta de un servicio";
      case "assignRouteItineraryUnrestricted":
        return "Asignar itinerario a un servicio sin restricción";

      //HELP DESK MODULE
      case "createTicket":
        return "Crear ticket";
      case "listTicket":
        return "Ver tickets";
      case "replyTechnicalTicket":
        return "Responder tickets de problemas técnicos";
      case "replyWebTicket":
        return "Responder tickets de problemas web";
      case "replyMobileTicket":
        return "Responder tickets de problemas en movil";
      case "replyOtherTicket":
        return "Responder tickets generales";
      case "reopenTicket":
        return "Re-abrir tickets";


      case "useCarNearExpirationDocuments":
        return "Utilizar vehículos con documentación próxima a expirar";

      case "approveBalanceDriver":
        return "Aprobar pago saldos";
      case "specialLicensePlate":
        return "Asignar licencia especial";

      //MONITORING MODULE
      case "monitorlogging":
        return "App logging";
      case "fingerprintslogging":
        return "Solicitudes por usuario";

      //ANALYTICS MODULE
      case "analyticsOperations":
        return "Operaciones";
      case "vehicleAnalytics":
        return "Vehículos";
      case "frequentRoutes":
        return "Rutas frecuentes";
      case "operationITR":
        return "Operación ITR";
      case "operationsTurn":
        return "Operaciones Enturnamiento";
      case "comercialTurn":
        return "Comercial Enturnamiento";
      case "vehiclesOwnFleet":
        return "Mis vehículos";
      case "reportUIAF":
        return "Reporte UIAF";
      case "fulfillments":
        return "Cumplidos";
      case "fulfillmentsClients":
        return "Cumplidos clientes";
      case "historicalDocuments":
        return "Histórico de documentos";
      case "profitabilityAnalysis":
        return "Análisis de rentabilidad";
      case "sicetac":
        return "Sicetac";
      case "dispatch":
        return "Despachos";
      case "stopedCargos":
        return "Servicios detenidos";
      case "historicalKPI":
        return "Métricas históricas";
      case "lostSales":
        return "Venta perdida";
      case "paymentsDashboard":
        return "Pagos";
      case "analyticsBilling":
        return "Facturación";
      //ROUTING MODULE
      case "createRouting":
        return "Crear ruteo";
      case "routingList":
        return "Listado de ruteos";
      //REPORTS MODULE
      case "reports":
        return "Reportes";
      case "cargoFinancialGeneral":
        return "Financiero";
      // FINTECH MODULE
      // Autenticación
      case "loggicash.auth.login.fromToken":
        return "Iniciar sesión con token";
      // Solicitudes de pago
      case "loggicash.paymentRequests.list":
        return "Listar de solicitudes de pago";
      case "loggicash.paymentRequests.view":
        return "Ver solicitud de pago";
      case "loggicash.paymentRequests.create":
        return "Crear solicitud de pago";
      case "loggicash.paymentRequests.update":
        return "Actualizar solicitud de pago";
      case "loggicash.paymentRequests.delete":
        return "Eliminar solicitud de pago";
      case "loggicash.paymentRequests.downloadReport":
        return "Descargar reporte de solicitudes de pago";
      // Payment 
      case "loggicash.payment.create":
        return "Crear simulación de pago";
      case "loggicash.payment.delete":
        return "Eliminar simulación de pago";
      case "loggicash.payment.update":
        return "Actualizar simulación de pago";
      case "loggicash.payment.downloadFile":
        return "Descargar archivo de pago";
      // Payment History
      case "loggicash.paymentHistory.view":
        return "Ver detalle de consolidado de pago"
      case "loggicash.paymentHistory.list":
        return "Listar consolidados de pago";
      case "loggicash.paymentHistory.update":
        return "Actualizar historial de pago";
      case "loggicash.paymentHistory.downloadReport":
        return "Descargar reporte de historial de pago";
      case "loggicash.paymentHistory.uploadFile":
        return "Subir archivo de evidencia de pago";
      // Billing
      case "loggicash.billing.list":
        return "Listar facturación";
      // Accounting
      case "loggicash.accounting.list":
        return "Listar contabilidad"
      // Seals
      case "adminSeals":
        return "Administrar Precintos";
      // Legal Documents
      case "adminLegalDocuments":
        return "Administrar Documentos Legales";
      // RNDC
      case "viewRndcStatus":
        return "Ver estado RNDC";
      // satelliteTracking
      case "forceMonitorTracking":
        return "Registro de Monitor automático";
      default:
        return functionality;
    }
  }
}
